module.exports = __webpack_public_path__ + "static/img/代写.b0e8e5d5.png";